export const DEFAULT = 0;
export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const INTERNAL = 3;

export const GROUP_TYPES = [
    DEFAULT,
    SUPER_ADMIN,
    ADMIN,
    INTERNAL
  ] as const;

  export type GroupTypes = typeof GROUP_TYPES[number];